import Annotation from 'components/Annotation'
import * as React from 'react'
import { Form } from 'react-bootstrap'

interface Props {
  name: string
  value?: string
  labelTop?: string
  labelLeft?: string
  ariaLabel?: string
  type: string
  pattern?: string
  maxLength?: number
  placeholder?: string
  bold?: boolean
  className?: string
  style?: React.CSSProperties
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  setValue?: (value: string) => void
  notes?: string[]
  errors?: string[]
}

const Component: React.FC<Props> = ({
  name,
  value,
  labelTop,
  labelLeft,
  ariaLabel,
  type,
  pattern,
  maxLength,
  placeholder,
  bold,
  className,
  style,
  disabled,
  onChange,
  onBlur,
  setValue,
  notes,
  errors,
}) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  const noteList = (notes ?? []).filter(Boolean)
  const errorList = (errors ?? []).filter(Boolean)
  return (
    <div id={`input_item_id_${name}`} className={className} style={{ ...{ textAlign: 'left' }, ...style }}>
      {labelTop && <Form.Label className={`font-15${bold ? ' fw-bold' : ''}`}>{labelTop}</Form.Label>}
      <div className="d-flex">
        {labelLeft && <div className={`align-self-center me-3 font-15${bold ? ' fw-bold' : ''}`}>{labelLeft}</div>}
        <Form.Control
          data-testid={name}
          className={`p-3${errorList.length > 0 ? ' border-danger border-2' : ' border-color-input'}`}
          name={name}
          value={value}
          type={type}
          disabled={disabled}
          pattern={pattern}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={originalOnChange}
          onBlur={onBlur}
          aria-label={ariaLabel}
        />
      </div>
      {noteList.length > 0 && <Annotation notes={noteList} />}
      {errorList.length > 0 && <Annotation notes={errorList} warn />}
    </div>
  )
}

export default Component
